import * as v from 'valibot';
import { formatPublicVars } from './format';

const EnvVarsSchema = v.object({
  REACT_APP_API_URL: v.pipe(v.string(), v.url()),
  REACT_APP_ORIGIN_API: v.pipe(v.string(), v.url()),

  REACT_APP_TRIMPLE_MAPS_API_KEY: v.string(),

  REACT_APP_OIDC_AUTHORITY: v.optional(v.union([v.string(), v.undefined()])),
  REACT_APP_OIDC_CLIENT_ID: v.optional(v.union([v.string(), v.undefined()])),

  REACT_APP_BLOB_FILE_URL: v.pipe(v.string(), v.url()),
  REACT_APP_RATE_UPS_AUTH: v.pipe(v.string(), v.url()),
  REACT_APP_THEME: v.string(),
  VERSION: v.optional(v.union([v.string(), v.undefined()])),

  REACT_APP_SSO_SPI_FLOW: v.optional(v.union([v.string(), v.undefined(), v.boolean()])),

  REACT_APP_FEATURE_SPOT_QUOTE_COPY_ENABLED: v.boolean(),
});

export type EnvVars = v.InferOutput<typeof EnvVarsSchema>;

export const validate = (envVars: EnvVars) =>
  // @ts-ignore
  // formatPublicVars additionally for vitest
  v.parse(EnvVarsSchema, formatPublicVars(envVars), {
    message: (issue) => `[ENV_VARS]:${issue.message}. ${JSON.stringify(issue, null, 2)}`,
  });
